
<script>
import options from "./AddedToCartNotification.options";
export default options;
</script>

<template>
    <transition name="fade">
        <div v-if="displayCartNotification" class="nti-cart-notification__overlay" v-on:click="closeNotification">
            <div class="nti-cart-notification__overlay-wrapper">
                <article class="nti-cart-notification">
                    <div v-html="getCartNotificationData"></div>
                    <section class="nti-cart-notification__confirmation__bottom">
                        <div class="nti-cart-notification__confirmation__button-container">
                            <button @click="continueShopping" class="nti-button nti-button--large-text nti-button--no-border pardotTrackClick" aria-label="Continue shopping" v-on:click="closeNotification">
                                {{ continueShoppingLabel }}
                            </button>
                            <a :href="toBasketUrl" class="nti-button nti-button--large-text nti-button__link pardotTrackClick" aria-label="Go to basket">
                                <p>{{ toBasketLabel }}</p>
                                <div class="nti-svg__container-small">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                        <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/>
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </section>
                </article>
            </div>
        </div>
    </transition>
</template>





